import n from "./api.js";
import { serviceCallback as s } from "./serviceCallback.js";
var i = function i(o) {
    var t = {
      url: n.sendMessageApi,
      method: "post",
      data: o
    };
    return s(t);
  },
  c = function c(o) {
    var t = {
      url: n.contractPaySignApi,
      method: "post",
      data: o
    };
    return s(t);
  },
  p = function p(o) {
    var t = {
      url: n.signRouting,
      method: "post",
      data: o
    };
    return s(t);
  };
export { c as contractPaySign, i as sendMessage, p as signRouting };
